import Immutable from "seamless-immutable";
import {
  REGISTRATION_REQUEST,
  REGISTRATION_SUCCESS,
  REGISTRATION_FAILURE,
  REGISTRATION_OTP_REQUEST,
  REGISTRATION_OTP_SUCCESS,
  REGISTRATION_OTP_FAILURE,
  REGISTRATION_OTP_VERIFY,
  REGISTRATION_OTP_VERIFY_SUCCESS,
  REGISTRATION_OTP_VERIFY_FAILURE,
  ACTIVATION_GENERIC_LINK_REQUEST,
  ACTIVATION_GENERIC_LINK_SUCCESS,
  ACTIVATION_GENERIC_LINK_FAILURE,
  ACTIVATION_GENERIC_OTP_VERIFY_REQ,
  ACTIVATION_GENERIC_OTP_VERIFY_SUCCESS,
  ACTIVATION_GENERIC_OTP_VERIFY_FAILURE,
  ACTIVATION_PERSONAL_LINK_REQ,
  ACTIVATION_PERSONAL_LINK_REQ_SUCCESS,
  ACTIVATION_PERSONAL_LINK_REQ_FAILURE,
  ACTIVATE_PERSONAL_REQ,
  ACTIVATE_PERSONAL_REQ_SUCCESS,
  ACTIVATE_PERSONAL_REQ_FAILURE,
  PROMPT_MOBILE_PHONE_INPUT,
  PROMPT_MOBILE_PHONE_INPUT_SUCCESS,
  PROMPT_MOBILE_PHONE_INPUT_FAILURE,
  UPDATE_CLIENT_INFO,
  UPDATE_CLIENT_INFO_SUCCESS,
  UPDATE_CLIENT_INFO_FAILURE,
  REGISTRATION_OTP_RESEND,
  REGISTRATION_OTP_RESEND_SUCCESS,
  REGISTRATION_OTP_RESEND_FAILURE,

  VALIDATE_MOVIE_REG,
  VALIDATE_MOVIE_REG_SUCCESS,
  VALIDATE_MOVIE_REG_FAILURE,
  SUBMIT_MOVIE_REG,
  SUBMIT_MOVIE_REG_SUCCESS,
  SUBMIT_MOVIE_REG_FAILURE,
  SUBMIT_CAMPAIGN_FORM_REQ,
  SUBMIT_CAMPAIGN_FORM_REQ_SUCCESS,
  SUBMIT_CAMPAIGN_FORM_REQ_FAILURE,
  CALCULATE_WALKWAG_AMOUNT_REQ,
  CALCULATE_WALKWAG_AMOUNT_REQ_SUCCESS,
  CALCULATE_WALKWAG_AMOUNT_REQ_FAILURE,
  CHECK_PAYNOW_QR_STATUS_REQ,
  CHECK_PAYNOW_QR_STATUS_REQ_SUCCESS,
  CHECK_PAYNOW_QR_STATUS_REQ_FAILURE,
  GET_REGISTRATION_CUSTOMER_DETAILS,
  GET_REGISTRATION_CUSTOMER_DETAILS_SUCCESS,
  GET_REGISTRATION_CUSTOMER_DETAILS_FAILURE,
  REGISTER_CUSTOMER,
  REGISTER_CUSTOMER_SUCCESS,
  REGISTER_CUSTOMER_FAILURE,

  //revamp2.0
  GET_REGISTRATION_CUSTOMER_INFO,
  GET_REGISTRATION_CUSTOMER_INFO_SUCCESS,
  GET_REGISTRATION_CUSTOMER_INFO_FAILURE,
  GET_LOGIN_TOKEN,
  GET_LOGIN_TOKEN_SUCCESS,
  GET_LOGIN_TOKEN_FAILURE,
  GENERATE_OTP_ONBOARDING,
  GENERATE_OTP_ONBOARDING_SUCCESS,
  GENERATE_OTP_ONBOARDING_FAILURE,
  REGISTER_NEW_CUSTOMERV2,
  REGISTER_NEW_CUSTOMERV2_SUCCESS,
  REGISTER_NEW_CUSTOMERV2_FAILURE,
  LOG_REGISTRATION_REQUEST,
  LOG_REGISTRATION_REQUEST_SUCCESS,
  LOG_REGISTRATION_REQUEST_FAILURE,
  VALIDATION_REGISTRATION,
  VALIDATION_REGISTRATION_SUCCESS,
  VALIDATION_REGISTRATION_FAILURE,
  UPLOAD_OCR_NRIC,
  UPLOAD_OCR_NRIC_SUCCESS,
  UPLOAD_OCR_NRIC_FAILURE,
  UPDATE_CLIENT_INFOV4_REQUEST,
  UPDATE_CLIENT_INFOV4_REQUEST_SUCCESS,
  UPDATE_CLIENT_INFOV4_REQUEST_FAILURE,
  RESET_REG
} from "../actions/registration";

const INITIAL_STATE = Immutable({
  registrationReq: null,
  registrationOtp: null,
  registrationOtpVerify: null,
  activationGenericLinkReq: null,
  activationGenericOTP: null,
  activationPersonalLinkReq: null,
  activatePersonalReq: null,
  promptMobilePhoneInput: null,
  updateClientInfo: null,
  registrationOTPResend: null,
  validateMovieReg: null,
  submitMovieReg: null,
  submitCampaignFormReq: null,
  calculateWalkWagAmountReq: null,
  checkPayNowQRStatusReq: null,
  getRegistrationCustomerDetails: null,
  registerNewCustomer: null,

  //revamp2.0
  getRegistrationCustomerInfo: null,
  getLoginToken: null,
  generateOTPOnboarding: null,
  registerNewCustomerV2: null,
  logRegistrationReq: null,
  validationReg: null,
  uploadOCRNRIC: null,
  updateClientInfoV4: null,
});

function registration(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REGISTRATION_REQUEST:
      return state
        .setIn(["registrationReq", "loading"], true)
        .setIn(["registrationReq", "status"], false);
    case REGISTRATION_SUCCESS:
      return state
        .setIn(["registrationReq", "loading"], false)
        .setIn(["registrationReq", "items"], action.data)
        .setIn(["registrationReq", "status"], true);
    case REGISTRATION_FAILURE:
      return state
        .setIn(["registrationReq", "loading"], false)
        .setIn(["registrationReq", "status"], false);
    case REGISTRATION_OTP_REQUEST:
      return state
        .setIn(["registrationOtp", "loading"], true)
        .setIn(["registrationOtp", "status"], false);
    case REGISTRATION_OTP_SUCCESS:
      return state
        .setIn(["registrationOtp", "loading"], false)
        .setIn(["registrationOtp", "items"], action.data)
        .setIn(["registrationOtp", "status"], true);
    case REGISTRATION_OTP_FAILURE:
      return state
        .setIn(["registrationOtp", "loading"], false)
        .setIn(["registrationOtp", "status"], false);
    case REGISTRATION_OTP_VERIFY:
      return state
        .setIn(["registrationOtpVerify", "loading"], true)
        .setIn(["registrationOtpVerify", "status"], false);
    case REGISTRATION_OTP_VERIFY_SUCCESS:
      return state
        .setIn(["registrationOtpVerify", "loading"], false)
        .setIn(["registrationOtpVerify", "items"], action.data)
        .setIn(["registrationOtpVerify", "status"], true);
    case REGISTRATION_OTP_VERIFY_FAILURE:
      return state
        .setIn(["registrationOtpVerify", "loading"], false)
        .setIn(["registrationOtpVerify", "status"], false);
    case ACTIVATION_GENERIC_LINK_REQUEST:
      return state
        .setIn(["activationGenericLinkReq", "loading"], true)
        .setIn(["activationGenericLinkReq", "status"], false);
    case ACTIVATION_GENERIC_LINK_SUCCESS:
      return state
        .setIn(["activationGenericLinkReq", "loading"], false)
        .setIn(["activationGenericLinkReq", "items"], action.data)
        .setIn(["activationGenericLinkReq", "status"], true);
    case ACTIVATION_GENERIC_LINK_FAILURE:
      return state
        .setIn(["activationGenericLinkReq", "loading"], false)
        .setIn(["activationGenericLinkReq", "status"], false);
    case ACTIVATION_GENERIC_OTP_VERIFY_REQ:
      return state
        .setIn(["activationGenericOTP", "loading"], true)
        .setIn(["activationGenericOTP", "status"], false);
    case ACTIVATION_GENERIC_OTP_VERIFY_SUCCESS:
      return state
        .setIn(["activationGenericOTP", "loading"], false)
        .setIn(["activationGenericOTP", "items"], action.data)
        .setIn(["activationGenericOTP", "status"], true);
    case ACTIVATION_GENERIC_OTP_VERIFY_FAILURE:
      return state
        .setIn(["activationGenericOTP", "loading"], false)
        .setIn(["activationGenericOTP", "status"], false);
    case ACTIVATION_PERSONAL_LINK_REQ:
      return state
        .setIn(["activationPersonalLinkReq", "loading"], true)
        .setIn(["activationPersonalLinkReq", "status"], false);
    case ACTIVATION_PERSONAL_LINK_REQ_SUCCESS:
      return state
        .setIn(["activationPersonalLinkReq", "loading"], false)
        .setIn(["activationPersonalLinkReq", "items"], action.data)
        .setIn(["activationPersonalLinkReq", "status"], true);
    case ACTIVATION_PERSONAL_LINK_REQ_FAILURE:
      return state
        .setIn(["activationPersonalLinkReq", "loading"], false)
        .setIn(["activationPersonalLinkReq", "status"], false);
    case ACTIVATE_PERSONAL_REQ:
      return state
        .setIn(["activatePersonalReq", "loading"], true)
        .setIn(["activatePersonalReq", "status"], false);
    case ACTIVATE_PERSONAL_REQ_SUCCESS:
      return state
        .setIn(["activatePersonalReq", "loading"], false)
        .setIn(["activatePersonalReq", "items"], action.data)
        .setIn(["activatePersonalReq", "status"], true);
    case ACTIVATE_PERSONAL_REQ_FAILURE:
      return state
        .setIn(["activatePersonalReq", "loading"], false)
        .setIn(["activatePersonalReq", "status"], false);
    case PROMPT_MOBILE_PHONE_INPUT:
      return state
        .setIn(["promptMobilePhoneInput", "loading"], true)
        .setIn(["promptMobilePhoneInput", "status"], false);
    case PROMPT_MOBILE_PHONE_INPUT_SUCCESS:
      return state
        .setIn(["promptMobilePhoneInput", "loading"], false)
        .setIn(["promptMobilePhoneInput", "items"], action.data)
        .setIn(["promptMobilePhoneInput", "status"], true);
    case PROMPT_MOBILE_PHONE_INPUT_FAILURE:
      return state
        .setIn(["promptMobilePhoneInput", "loading"], false)
        .setIn(["promptMobilePhoneInput", "status"], false);
    case UPDATE_CLIENT_INFO:
      return state
        .setIn(["updateClientInfo", "loading"], true)
        .setIn(["updateClientInfo", "status"], false);
    case UPDATE_CLIENT_INFO_SUCCESS:
      return state
        .setIn(["updateClientInfo", "loading"], false)
        .setIn(["updateClientInfo", "items"], action.data)
        .setIn(["updateClientInfo", "status"], true);
    case UPDATE_CLIENT_INFO_FAILURE:
      return state
        .setIn(["updateClientInfo", "loading"], false)
        .setIn(["updateClientInfo", "status"], false);
    case REGISTRATION_OTP_RESEND:
      return state
        .setIn(["registrationOTPResend", "loading"], true)
        .setIn(["registrationOTPResend", "status"], false);
    case REGISTRATION_OTP_RESEND_SUCCESS:
      return state
        .setIn(["registrationOTPResend", "loading"], false)
        .setIn(["registrationOTPResend", "items"], action.data)
        .setIn(["registrationOTPResend", "status"], true);
    case REGISTRATION_OTP_RESEND_FAILURE:
      return state
        .setIn(["registrationOTPResend", "loading"], false)
        .setIn(["registrationOTPResend", "status"], false);

    case VALIDATE_MOVIE_REG:
      return state
        .setIn(["validateMovieReg", "loading"], true)
        .setIn(["validateMovieReg", "status"], false);
    case VALIDATE_MOVIE_REG_SUCCESS:
      return state
        .setIn(["validateMovieReg", "loading"], false)
        .setIn(["validateMovieReg", "items"], action.data)
        .setIn(["validateMovieReg", "status"], true);
    case VALIDATE_MOVIE_REG_FAILURE:
      return state
        .setIn(["validateMovieReg", "loading"], false)
        .setIn(["validateMovieReg", "status"], false);

    case SUBMIT_MOVIE_REG:
      return state
        .setIn(["submitMovieReg", "loading"], true)
        .setIn(["submitMovieReg", "status"], false);
    case SUBMIT_MOVIE_REG_SUCCESS:
      return state
        .setIn(["submitMovieReg", "loading"], false)
        .setIn(["submitMovieReg", "items"], action.data)
        .setIn(["submitMovieReg", "status"], true);
    case SUBMIT_MOVIE_REG_FAILURE:
      return state
        .setIn(["submitMovieReg", "loading"], false)
        .setIn(["submitMovieReg", "status"], false);

    case SUBMIT_CAMPAIGN_FORM_REQ:
      return state
        .setIn(["submitCampaignFormReq", "loading"], true)
        .setIn(["submitCampaignFormReq", "status"], false);
    case SUBMIT_CAMPAIGN_FORM_REQ_SUCCESS:
      return state
        .setIn(["submitCampaignFormReq", "loading"], false)
        .setIn(["submitCampaignFormReq", "items"], action.data)
        .setIn(["submitCampaignFormReq", "status"], true);
    case SUBMIT_CAMPAIGN_FORM_REQ_FAILURE:
      return state
        .setIn(["submitCampaignFormReq", "loading"], false)
        .setIn(["submitCampaignFormReq", "status"], false);

    case CALCULATE_WALKWAG_AMOUNT_REQ:
      return state
        .setIn(["calculateWalkWagAmountReq", "loading"], true)
        .setIn(["calculateWalkWagAmountReq", "status"], false);
    case CALCULATE_WALKWAG_AMOUNT_REQ_SUCCESS:
      return state
        .setIn(["calculateWalkWagAmountReq", "loading"], false)
        .setIn(["calculateWalkWagAmountReq", "items"], action.data)
        .setIn(["calculateWalkWagAmountReq", "status"], true);
    case CALCULATE_WALKWAG_AMOUNT_REQ_FAILURE:
      return state
        .setIn(["calculateWalkWagAmountReq", "loading"], false)
        .setIn(["calculateWalkWagAmountReq", "status"], false);

    case CHECK_PAYNOW_QR_STATUS_REQ:
      return state
        .setIn(["checkPayNowQRStatusReq", "loading"], true)
        .setIn(["checkPayNowQRStatusReq", "status"], false);
    case CHECK_PAYNOW_QR_STATUS_REQ_SUCCESS:
      return state
        .setIn(["checkPayNowQRStatusReq", "loading"], false)
        .setIn(["checkPayNowQRStatusReq", "items"], action.data)
        .setIn(["checkPayNowQRStatusReq", "status"], true);
    case CHECK_PAYNOW_QR_STATUS_REQ_FAILURE:
      return state
        .setIn(["checkPayNowQRStatusReq", "loading"], false)
        .setIn(["checkPayNowQRStatusReq", "status"], false);

    case GET_REGISTRATION_CUSTOMER_DETAILS:
      return state
        .setIn(["getRegistrationCustomerDetails", "loading"], true)
        .setIn(["getRegistrationCustomerDetails", "status"], false);
    case GET_REGISTRATION_CUSTOMER_DETAILS_SUCCESS:
      return state
        .setIn(["getRegistrationCustomerDetails", "loading"], false)
        .setIn(["getRegistrationCustomerDetails", "items"], action.data)
        .setIn(["getRegistrationCustomerDetails", "status"], true);
    case GET_REGISTRATION_CUSTOMER_DETAILS_FAILURE:
      return state
        .setIn(["getRegistrationCustomerDetails", "loading"], false)
        .setIn(["getRegistrationCustomerDetails", "status"], false);

    case REGISTER_CUSTOMER:
      return state
        .setIn(["registerNewCustomer", "loading"], true)
        .setIn(["registerNewCustomer", "status"], false);
    case REGISTER_CUSTOMER_SUCCESS:
      return state
        .setIn(["registerNewCustomer", "loading"], false)
        .setIn(["registerNewCustomer", "items"], action.data)
        .setIn(["registerNewCustomer", "status"], true);
    case REGISTER_CUSTOMER_FAILURE:
      return state
        .setIn(["registerNewCustomer", "loading"], false)
        .setIn(["registerNewCustomer", "status"], false);

    //revamp2.0
    case GET_REGISTRATION_CUSTOMER_INFO:
      return state
        .setIn(["getRegistrationCustomerInfo", "loading"], true)
        .setIn(["getRegistrationCustomerInfo", "status"], false);
    case GET_REGISTRATION_CUSTOMER_INFO_SUCCESS:
      return state
        .setIn(["getRegistrationCustomerInfo", "loading"], false)
        .setIn(["getRegistrationCustomerInfo", "items"], action.data)
        .setIn(["getRegistrationCustomerInfo", "status"], true);
    case GET_REGISTRATION_CUSTOMER_INFO_FAILURE:
      return state
        .setIn(["getRegistrationCustomerInfo", "loading"], false)
        .setIn(["getRegistrationCustomerInfo", "status"], false);

    case GET_LOGIN_TOKEN:
      return state
        .setIn(["getLoginToken", "loading"], true)
        .setIn(["getLoginToken", "status"], false);
    case GET_LOGIN_TOKEN_SUCCESS:
      return state
        .setIn(["getLoginToken", "loading"], false)
        .setIn(["getLoginToken", "items"], action.data)
        .setIn(["getLoginToken", "status"], true);
    case GET_LOGIN_TOKEN_FAILURE:
      return state
        .setIn(["getLoginToken", "loading"], false)
        .setIn(["getLoginToken", "status"], false);

    case GENERATE_OTP_ONBOARDING:
      return state
        .setIn(["generateOTPOnboarding", "loading"], true)
        .setIn(["generateOTPOnboarding", "status"], false);
    case GENERATE_OTP_ONBOARDING_SUCCESS:
      return state
        .setIn(["generateOTPOnboarding", "loading"], false)
        .setIn(["generateOTPOnboarding", "items"], action.data)
        .setIn(["generateOTPOnboarding", "status"], true);
    case GENERATE_OTP_ONBOARDING_FAILURE:
      return state
        .setIn(["generateOTPOnboarding", "loading"], false)
        .setIn(["generateOTPOnboarding", "status"], false);

    case REGISTER_NEW_CUSTOMERV2:
      return state
        .setIn(["registerNewCustomerV2", "loading"], true)
        .setIn(["registerNewCustomerV2", "status"], false);
    case REGISTER_NEW_CUSTOMERV2_SUCCESS:
      return state
        .setIn(["registerNewCustomerV2", "loading"], false)
        .setIn(["registerNewCustomerV2", "items"], action.data)
        .setIn(["registerNewCustomerV2", "status"], true);
    case REGISTER_NEW_CUSTOMERV2_FAILURE:
      return state
        .setIn(["registerNewCustomerV2", "loading"], false)
        .setIn(["registerNewCustomerV2", "status"], false);

    case LOG_REGISTRATION_REQUEST:
      return state
        .setIn(["logRegistrationReq", "loading"], true)
        .setIn(["logRegistrationReq", "status"], false);
    case LOG_REGISTRATION_REQUEST_SUCCESS:
      return state
        .setIn(["logRegistrationReq", "loading"], false)
        .setIn(["logRegistrationReq", "items"], action.data)
        .setIn(["logRegistrationReq", "status"], true);
    case LOG_REGISTRATION_REQUEST_FAILURE:
      return state
        .setIn(["logRegistrationReq", "loading"], false)
        .setIn(["logRegistrationReq", "status"], false);

    case VALIDATION_REGISTRATION:
      return state
        .setIn(["validationReg", "loading"], true)
        .setIn(["validationReg", "status"], false);
    case VALIDATION_REGISTRATION_SUCCESS:
      return state
        .setIn(["validationReg", "loading"], false)
        .setIn(["validationReg", "items"], action.data)
        .setIn(["validationReg", "status"], true);
    case VALIDATION_REGISTRATION_FAILURE:
      return state
        .setIn(["validationReg", "loading"], false)
        .setIn(["validationReg", "status"], false);

    case UPLOAD_OCR_NRIC:
      return state
        .setIn(["uploadOCRNRIC", "loading"], true)
        .setIn(["uploadOCRNRIC", "status"], false);
    case UPLOAD_OCR_NRIC_SUCCESS:
      return state
        .setIn(["uploadOCRNRIC", "loading"], false)
        .setIn(["uploadOCRNRIC", "items"], action.data)
        .setIn(["uploadOCRNRIC", "status"], true);
    case UPLOAD_OCR_NRIC_FAILURE:
      return state
        .setIn(["uploadOCRNRIC", "loading"], false)
        .setIn(["uploadOCRNRIC", "status"], false);

    case UPDATE_CLIENT_INFOV4_REQUEST:
      return state
        .setIn(["updateClientInfoV4", "loading"], true)
        .setIn(["updateClientInfoV4", "status"], false);
    case UPDATE_CLIENT_INFOV4_REQUEST_SUCCESS:
      return state
        .setIn(["updateClientInfoV4", "loading"], false)
        .setIn(["updateClientInfoV4", "items"], action.data)
        .setIn(["updateClientInfoV4", "status"], true);
    case UPDATE_CLIENT_INFOV4_REQUEST_FAILURE:
      return state
        .setIn(["updateClientInfoV4", "loading"], false)
        .setIn(["updateClientInfoV4", "status"], false);
    case RESET_REG:
      return INITIAL_STATE;


    default:
      return state;
  }
}

export default registration;
